import React from 'react';
import PropTypes from 'prop-types';
import styles from './EditSavedSearchModal.scss';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

const EditSavedSearchFormSchema = Yup.object().shape({
  name: Yup.string().required('Required'),
  alertFrequency: Yup.string(),
  searchId: Yup.string(),
});

const EditSavedSearchModal = (props) => {
  const {
    closeModal,
    name,
    query,
    sort,
    alertFrequency,
    searchId,
    updateSavedSearch,
  } = props;

  const handleCancelClick = (event) => {
    event.preventDefault();
    closeModal({open: false});
  };

  const handleSubmit = (values) => {
    updateSavedSearch(values);
    closeModal({open: false});
  };

  return (
    <div className={styles.container}>
      <Formik
        initialValues={{
          name,
          query,
          sort,
          alertFrequency,
          searchId,
        }}
        validationSchema={EditSavedSearchFormSchema}
        onSubmit={handleSubmit}
      >{({values}) => (
          <Form>
            <Field
              id="name"
              name="name"
              className={`${styles.addressField} mb-4`}
              autocomplete="off"
            />
            <div className="d-flex flex-row justify-content-center">
              <a className={styles.cancelButton} onClick={handleCancelClick}>Cancel</a>
              <button
                className={`odinButton ${styles.submitButton} ${!values.name ? styles.disabled : ''}`}
                type="submit"
                disabled={!values.name}
              >
                Save
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

EditSavedSearchModal.propTypes = {
  name: PropTypes.string,
  query: PropTypes.object,
  sort: PropTypes.array,
  alertFrequency: PropTypes.string,
  searchId: PropTypes.string,
  closeModal: PropTypes.func,
  updateSavedSearch: PropTypes.func,
};

export default EditSavedSearchModal;
